import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { useContactModal } from './ContactModalContext';

export function ContactModalTrigger({ subject, body, children, className, style }) {
  const { openContact } = useContactModal();

  return (
    <button
      type="button"
      className={className}
      style={style}
      onClick={() => openContact({ subject, body })}
    >
      {children}
    </button>
  );
}

export default function ContactFormModal({ isOpen, onClose, subject, body }) {
  const { strings } = useLanguage();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const nameRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setName('');
      setEmail('');
      setMessage('');
      setSending(false);
      setSent(false);
      return undefined;
    }

    setName('');
    setEmail('');
    setMessage(body || '');
    setSending(false);
    setSent(false);
    const focusTimer = setTimeout(() => nameRef.current?.focus(), 50);
    return () => clearTimeout(focusTimer);
  }, [isOpen, body]);

  const sendEmail = async (event) => {
    try {
      const response = await fetch(process.env.REACT_APP_EMAIL_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: event.target.user_email.value,
          name: event.target.user_name.value,
          message: event.target.message.value,
          subject: subject || strings.contactForm?.mailSubject,
        }),
      });
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error('Error sending email:', error);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSending(true);
    sendEmail(event);
    setTimeout(() => {
      setSending(false);
      setSent(true);
    }, 800);
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="image-modal-overlay" onClick={onClose}>
      <div className="image-modal-wrapper" onClick={(event) => event.stopPropagation()}>
        <div className="contact-modal" role="dialog" aria-modal="true">
          <button className="image-modal-close" onClick={onClose} aria-label="Close contact form">×</button>
          <h3>{strings.contactForm?.title ?? 'Contact'}</h3>
          {!sent ? (
            <form className="contact-form" onSubmit={handleSubmit}>
              <label className="sr-only" htmlFor="user_name">Name</label>
              <input id="user_name" name="user_name" ref={nameRef} value={name} onChange={(event) => setName(event.target.value)} placeholder={strings.contactForm?.namePlaceholder ?? 'Your name'} />
              <label className="sr-only" htmlFor="user_email">Email</label>
              <input type="email" id="user_email" name="user_email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder={strings.contactForm?.emailPlaceholder ?? 'Your email'} />
              <label className="sr-only" htmlFor="message">Message</label>
              <textarea id="message" name="message" value={message} onChange={(event) => setMessage(event.target.value)} placeholder={strings.contactForm?.messagePlaceholder ?? 'Your message'} />
              <button type="submit" className="contact-send" disabled={sending}>
                {sending ? 'Sending...' : (strings.contactForm?.sendButton ?? 'Send message')}
              </button>
            </form>
          ) : (
            <div className="contact-sent">{strings.contactForm?.sentMessage ?? 'Thanks — your message has been sent.'}</div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}